export const BASE_PATH = import.meta.env.VITE_ASSET_PATH || '';

const AUTH = '/auth/';
export const PREVIEW_PATH = 'preview';
export const TEMPLATES_PATH = '/templates/';

export const ROUTE_CODES = {
  AUTH,
  HOME: '/',
  LOGIN: `${AUTH}login/`,
  DESKTOP_LOGIN: `${AUTH}desktop-login/`,

  SCRIBE_NEW: '/new-project/',
  SCRIBE_DELETE: '/delete/:scribeId',
  TEMPLATE_PREVIEW: '/template-preview/:templateId',
  TEMPLATES_CATEGORY: `${TEMPLATES_PATH}:categoryName?`,
  RENDER: '/render/:scribeId/:startTime?/:duration?',
  PREVIEW: `/${PREVIEW_PATH}/:publicSharingId`,
  EDITOR: '/editor/:scribeId',
  SHARE: '/share/',
  DOWNLOAD: '/download/',
  ENABLE_COLOR_CHANGE: '/enable-color-change/',
  MIGRATE_SCRIBE: '/migrate-legacy-project/'
};
